import type { GetTweets200PageAllOfThreeContentItemBasicInfoAllOfTwoTweetType } from './getTweets200PageAllOfThreeContentItemBasicInfoAllOfTwoTweetType';

/**
 * 트윗 기본 정보
 */
export type GetTweets200PageAllOfThreeContentItemBasicInfoAllOfTwo = {
  content: string;
  /** 트윗 유형 */
  tweetType?: GetTweets200PageAllOfThreeContentItemBasicInfoAllOfTwoTweetType;
};
